// extracted by mini-css-extract-plugin
export default {"item":"styles__item--KkAfp","code":"styles__code--gtsoT","description":"styles__description--yTnXb"};